type LeadOpts = {
  brandId: string;
  clientSideId: string;
  cookies: any;
  email: string;
  type: string;
  transactionUrl: string;
  userAgent: string;
  metadata: any;
};

const createLead = async (opts: LeadOpts) => {
  const body = {
    brandId: opts.brandId,
    clientSideId: opts.clientSideId,
    cookies: opts.cookies,
    email: opts.email,
    type: opts.type,
    transactionUrl: opts.transactionUrl,
    userAgent: opts.userAgent,
    metadata: opts.metadata,
  };
  const createdLeadResp = await fetch("/api/leads/createOrUpdateLead/", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
  return createdLeadResp;
};

export default createLead;
